import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Applications from './applications';

const Profile = () => {
  return (
    <Routes>
      <Route path={`/applications`} element={<Applications />} />
    </Routes>
  );
};

export default Profile;
